var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { formatCurrency, formatDisplayDate } from "syf-js-utilities";
import { AdditionalValue, DescriptionValueContainer, FeaturedValue, Value, SubAdditionalLabelContainer, } from "./subcomponents";
import formatMonth from "../../../helpers/formatMonth";
var DescriptionDetail = function (_a) {
    var additionalValue = _a.additionalValue, type = _a.type, value = _a.value, isLargerText = _a.isLargerText, subAdditionalLabel = _a.subAdditionalLabel;
    var t = useTranslation().t;
    var renderValue = function (dataType, dataValue) {
        if (dataValue === null || dataValue === undefined) {
            return t("error.uiComponent");
        }
        switch (dataType) {
            case "date":
                return formatDisplayDate("".concat(dataValue));
            case "amount":
                return formatCurrency(dataValue);
            case "percentage":
                return "".concat(value, "%");
            case "months":
                return formatMonth("".concat(dataValue), t);
            default:
                return dataValue;
        }
    };
    return (_jsxs(DescriptionValueContainer, { children: [subAdditionalLabel ? (_jsx(SubAdditionalLabelContainer, __assign({ "data-cy": "subAdditional-label", status: subAdditionalLabel.status }, { children: subAdditionalLabel.displayText }))) : undefined, isLargerText ? (_jsx(FeaturedValue, __assign({ as: "dd", "data-cy": "value" }, { children: renderValue(type, value) }))) : (_jsx(Value, __assign({ as: "dd", "data-cy": "value" }, { children: renderValue(type, value) }))), additionalValue && (_jsxs(AdditionalValue, __assign({ as: "dd", "data-cy": "additional-value" }, { children: ["(", additionalValue, ")"] })))] }));
};
export default DescriptionDetail;
//# sourceMappingURL=DescriptionDetail.js.map